import { t } from 'i18next';
import React, { memo } from 'react';
import { CONSOLE_OPTIONS, PROVIDERS } from './../../content/constants';
import styles from './style.module.css';

const SocialAuthProvider = ({ label, onClickProvider, isConsole }) => {
  const providers = isConsole ? CONSOLE_OPTIONS: PROVIDERS;
  return (
    <div className={styles.social_auth_wrapper}>
      <p className={styles.social_auth_label}>{label}</p>
      <ul className={styles.social_auth_container}>
        {providers.map((provider) => (
          <li
            className={`${styles.slbtn} ${styles[`sl_${provider.name}`]}`}
            id={`id-${provider.name}`}
            key={provider.name}
            onClick={() => onClickProvider(provider.name)}
            data-testid={`social-login-with-${provider.name}-button`}
          >
            <div
              className={styles.logo_container}
              >
              <img
                alt={provider.displayText}
                height="24"
                width="24"
                src={`https://ik.imagekit.io/gupshup/revamp/common-login/${provider.icon}?ik-sdk-version=react-1.1.0`}
              />
              <span className={styles.provider_name}>{t(provider.name)}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(SocialAuthProvider);
